<div class="terms-page">
  <div class="terms-card">
    <header class="terms-header">
      <h1>Opšti uslovi kupovine i korišćenja ulaznica za zatvorene i otvorene bazene</h1>
      <p class="terms-subtitle">SPD RADNIČKI DOO KRAGUJEVAC — preko Aplikacije</p>
      <p class="terms-updated">Primenjuju se počev od: {{ lastUpdated }}</p>
    </header>

    <section class="terms-section">
      <h2>I Uvod</h2>
      <p>
        Ovi Opšti uslovi (u daljem tekstu označeni i kao: Opšti uslovi ili Uslovi) definišu
        uslove prodaje ulaznica za bazene putem interneta preko mobilne Aplikacije SPD Radnički
        (u daljem tekstu: Aplikacija), a u skladu sa odredbama članova 142-143 Zakona o
        obligacionim odnosima Republike Srbije („Sl. list SFRJ”, br. 29/78, 39/85, 45/89 –
        odluka USJ i 57/89, „Sl. list SRJ”, br. 31/93 i „Sl. list SCG”, br. 1/2003 – Ustavna
        povelja). Ovim Opštim uslovima definišu se svi odnosi između Trgovca i Kupca u vezi sa
        prodajom ulaznica preko Aplikacije kao i uslovi korišćenja Aplikacije, a u skladu sa
        važećim propisima Republike Srbije.
      </p>
      <p>
        Kupovinom ulaznica posredstvom Aplikacije, Kupac se u celini saglašava sa sadržinom i
        primenom ovih Opštih uslova na sve odnose između Trgovca i Kupca u vezi sa izvršenom
        kupovinom, osim ukoliko je pisanim putem između Trgovca i Kupca izričito drugačije
        dogovoreno. Preuzimanjem, instaliranjem ili korišćenjem Aplikacije, saglasni ste da
        budete vezani ovim Uslovima. Ukoliko se ne slažete sa ovim Uslovima, nemojte koristiti
        Aplikaciju. Naša Politika privatnosti dopunjuje ove Uslove korišćenja i nalazi se na
        internet stranici
        <a href="https://www.spdradnickikragujevac.com/" target="_blank" rel="noopener">https://www.spdradnickikragujevac.com/</a>.
        Preporučujemo da pažljivo pročitate ove informacije i povremeno proveravate ažuriranja.
      </p>
      <p>Ovim Opštim uslovima poslovanja definišu se:</p>
      <ul>
        <li>Uslovi korišćenja Aplikacije;</li>
        <li>Opšti uslovi kupovine i korišćenja ulaznica;</li>
        <li>Rešavanje reklamacija Kupaca;</li>
        <li>Pravo Kupca na odustanak od Ugovora i druga prava Kupca u skladu sa Zakonom o zaštiti potrošača;</li>
        <li>Zaštita podataka o ličnosti;</li>
        <li>druga pitanja od značaja za Ugovorni odnos Trgovca i Kupca.</li>
      </ul>
    </section>

    <section class="terms-section">
      <h2>II Definicije</h2>
      <p>
        Za potrebe ovih Uslova sledeće reči i izrazi imaće značenje definisano ovde:
      </p>
      <p>
        <strong>Trgovac</strong> – SPD RADNIČKI DOO KRAGUJEVAC, privredno društvo osnovano i
        registrovano u skladu sa propisima Republike Srbije sa registrovanim sedištem na adresi
        Ulica Grada Sirena br. 15, matični broj: 07150717, PIB: 101315191, čija je pretežna
        registrovana delatnost 9312 - delatnost sportskih klubova, kontakt telefon: 034 331 958,
        mejl: <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.
      </p>
      <p>
        <strong>Kupac</strong> – fizičko ili pravno lice koje posredstvom aplikacije putem
        interneta od Trgovca kupuje Ulaznice za otvorene i zatvorene bazene Trgovca koji se
        nalaze na adresi Dragutina Kojića 2, Kragujevac (u daljem tekstu: Bazeni).
      </p>
      <p>
        <strong>Ulaznice</strong> – ulaznice za korišćenje Bazena Trgovca, čiji spisak kao i
        cene su dati u Aplikaciji.
      </p>
      <p>
        <strong>Aplikacija</strong> – Aplikacija SPD Radnički putem koje se vrši internet
        kupovina Ulaznica od strane Kupaca.
      </p>
    </section>

    <section class="terms-section">
      <h2>Cene</h2>
      <p>
        PDV je uračunat u cenu i nema skrivenih troškova. Cene se prikazuju u dinarima (RSD).
        Sva plaćanja biće izvršena u lokalnoj valuti Republike Srbije – dinar (RSD). Za
        informativni prikaz cena u drugim valutama koristi se kurs Narodne Banke Srbije. Iznos
        za koji će biti zadužena Vaša platna kartica biće izražen u Vašoj lokalnoj valuti kroz
        konverziju u istu po kursu koji koriste kartičarske organizacije / Vaša banka izdavalac,
        a koji nama u trenutku transakcije ne može biti poznat. Kao rezultat ove konverzije
        postoji mogućnost neznatne razlike od originalne cene navedene u Aplikaciji i one koju
        možete videti na vašem bankovnom izvodu.
      </p>
      <p>
        S obzirom na to da svaka zemlja nezavisno određuje zakone koji regulišu promet roba i
        usluga, mogu se javiti situacije u kojima NEZAVISNO OD NAS određene državne službe uvedu
        dodatne poreze, takse ili dažbine na izvršene transakcije. SPD Radnički ne snosi
        odgovornost za takva obračunavanja, a kupci se obavezuju da samostalno reše sva pitanja
        vezana za njihovu uplatu.
      </p>
    </section>

    <section class="terms-section">
      <h2>III Uslovi korišćenja Aplikacije</h2>
      <p>
        Aplikacija se preuzima na mobilni telefon Kupca putem Google Play prodavnice ili App
        Store-a. Potrebno je da se na početnom ekranu izabere opcija „Registruj se”. Tokom
        registracije Kupac unosi svoje ime, prezime, e-mail adresu i lozinku koju će koristiti
        za buduće prijavljivanje u aplikaciju, kao i da prihvati Uslove korišćenja i Politiku
        privatnosti. Tek nakon što su sva obavezna polja popunjena i navedeni uslovi prihvaćeni,
        korisnički nalog Kupca se uspešno kreira.
      </p>
      <p>
        Po završetku registracije Kupac se vraća na ekran za prijavu, gde se u Aplikaciju
        prijavljuje korišćenjem registrovane e-mail adrese i lozinke.
      </p>
      <p>
        Nakon prijavljivanja, na stranici Profil, izborom opcije Plaćanje, Kupac prelazi na
        ekran za izbor paketa/ulaznica. Nakon odabira željene Ulaznice potrebno je da Kupac
        klikne na dugme „Nastavi”, nakon čega će biti preusmeren na platnu stranicu sistema
        Payspot, gde završava proces kupovine odabranog paketa.
      </p>
      <p>
        Po uspešno izvršenoj uplati, Kupcu na registrovanu e-mail adresu stiže potvrda o
        izvršenom plaćanju, kao i obrazac za odustanak od ugovora.
      </p>
      <p>
        Na ekranu Ulaz prikazan je korisnikov QR kod, koji ostaje neaktivan sve dok uplata nije
        uspešno realizovana. Nakon uspešne realizacije kupovine, QR kod postaje aktivan i Kupac
        ga može koristiti za prijavu (čekiranje) na Bazenima.
      </p>
    </section>

    <section class="terms-section">
      <h2>IV Opšti uslovi kupovine i korišćenja Ulaznica</h2>
      <h3>Način kupovine Ulaznica</h3>
      <p>
        Ovim delom Uslova regulišu se uslovi pod kojima Trgovac prodaje, a Kupac kupuje i
        koristi Ulaznice za Bazene kroz aplikaciju.
      </p>
      <p>
        Kupovinom ulaznice Kupac potvrđuje da je upoznat sa vrstom kupljene ulaznice, cenom,
        periodom njenog važenja, terminima u kojima se može koristiti, koji podaci su objavljeni
        na sajtu Trgovca
        <a href="https://www.bazenikragujevac.com/" target="_blank" rel="noopener">https://www.bazenikragujevac.com/</a>.
      </p>
      <p>
        Kupovinom ulaznice Kupac stiče pravo korišćenja usluga Bazena isključivo u skladu sa
        vrstom kupljene ulaznice, rasporedom termina koji je objavljen na gore navedenom sajtu i
        Pravilnikom o ponašanju na bazenima i jezeru u sportskom privrednom društvu „Radnički”
        doo Kragujevac koji je istaknut u objektima u kojima se nalaze Bazeni.
      </p>
      <p>
        Kupac izjavljuje da će se blagovremeno upoznati sa svim drugim pravilima ponašanja koja
        je Trgovac istakao na vidljivo mesto na Bazenima koje je dužan da poštuje.
      </p>
      <p>
        Nakon započetog korišćenja Ulaznice (mesečne, godišnje...), Kupac nema pravo na povraćaj
        uplaćenih sredstava niti na delimičnu refundaciju cene karte, osim u slučajevima kada je
        pravo na refundaciju izričito propisano važećim propisima.
      </p>
      <p>
        Ulaznice preko Aplikacije se kupuju isključivo elektronski, putem online plaćanja
        platnim karticama.
      </p>
      <p>
        Sva plaćanja se obrađuju putem pouzdanih spoljnih sistema plaćanja. Plaćanje putem
        prihvatanja platnih kartica (Visa, Dina, Master, Maestro) obavlja se preko sledećih
        pružaoca usluga: Institucije elektronskog novca PaySpot doo Novi Sad, sa sedištem u
        Novom Sadu, ul. Branimira Ćosića 2/II/201B, MB: 21157074, PIB: 109296534, i Raiffeisen
        Banke a.d. Beograd, sa registrovanim sedištem u Beogradu, Đorđa Stanojevića 16, MB:
        17335600, PIB: 10000029 (u daljem tekstu: Banka).
      </p>
      <p>
        Kupac je, kako bi realizovao kupovinu proizvoda, dužan da na označenoj sigurnoj formi
        stranice unese podatke svoje platne kartice. Ukoliko je transakcija izvršena, kupac će
        biti obavešten da je rezervacija sredstava u iznosu kreirane porudžbine uspešno
        obavljena. Prihvatanjem ovih Uslova korišćenja kupac je saglasan da mu se u momentu
        inicijalnog poručivanja rezervišu sredstva u iznosu kreirane porudžbine, kao i da se
        njegova platna kartica zaduži za iznos sa računa za realizovanu kupovinu proizvoda.
        Podaci o platnoj kartici čuvaju se na sigurnoj zaštićenoj stranici Banke u kriptovanoj
        formi i nisu dostupni drugim stranama u procesu plaćanja. Podaci o platnoj kartici ni
        jednog trenutka nisu dostupni SPD Radnički, aplikaciji, ni Instituciji. Prilikom
        unošenja podataka o platnoj kartici, poverljive informacije se prenose putem javne mreže
        u zaštićenoj (kriptovanoj) formi upotrebom SSL protokola i PKI Sistema, kao trenutno
        najsavremenije kriptografske tehnologije. U slučaju povraćaja novca kupcu (reklamacija,
        odustanak od kupovine, itd.), povraćaj sredstava će biti izvršen na karticu, odnosno na
        tekući račun kupca uz njegovu saglasnost. Prilikom povraćaja novca kupac će učiniti
        dostupnim podatak o tekućem računu na koji se imaju vratiti sredstva, što predstavlja
        podatak o ličnosti, koji je zaštićen u skladu sa Politikom privatnosti. U slučaju
        povraćaja sredstava kupcu koji je prethodno platio nekom od platnih kartica, delimično
        ili u celosti, a bez obzira na razlog vraćanja, SPD Radnički je u obavezi da povraćaj
        vrši isključivo preko VISA, EC/MC, Maestro i Dinacard metoda plaćanja, što znači da će
        Banka na zahtev obaviti povraćaj sredstava na račun kupca platne kartice. S tim da se za
        svaku registrovanu karticu (bila jedna ili više) obavlja provera validnosti kartice i
        kupca. Unos i prenos ličnih podataka i podataka o broju kartice zaštićeni su u skladu sa
        vodećim bezbednosnim protokolima na Internetu i u skladu sa PCI DSS standardima za
        sigurna plaćanja.
      </p>
      <p>
        Plaćanje putem digitalnih novčanika — moguće je korišćenje Google Pay i Apple Pay. Kupac
        potvrđuje transakciju biometrijom (otisak prsta, prepoznavanje lica) ili PIN-om na svom
        mobilnom uređaju, što predstavlja pristanak na izvršenje transakcije.
      </p>
      <p>
        Trgovac nije dužan da proverava da li je Kupac ovlašćen za upotrebu platne kartice koju
        je prezentovao Trgovcu, odnosno Procesoru platnih kartica i čije podatke je uneo prilikom
        kupovine Ulaznica, te nije odgovoran za bilo koju vrstu zloupotrebe kartice od strane
        Kupca ili trećeg lica.
      </p>
      <p>
        Prilikom kupovine Ulaznica, Kupac unošenjem adrese e-pošte kreira svoj korisnički nalog.
        Sistem Trgovca vrši automatsko povezivanje adrese e-pošte sa korisničkim nalogom i tom
        prilikom svakom korisničkom nalogu dodeljuje jedinstveni ID broj. Jedan korisnički nalog
        može biti povezan isključivo sa jednom adresom e-pošte. Obaveza plaćanja naknade za
        kupljene Ulaznice vezuje se za svaki korisnički nalog posebno, nezavisno od toga da li je
        isto lice vlasnik više korisničkih naloga registrovanih posredstvom različitih adresa
        e-pošte.
      </p>
      <p>
        Shodno tome, Kupac je isključivo odgovoran ukoliko iz razloga koji se tiču Kupca izvrši
        kupovinu Ulaznice posredstvom više registrovanih naloga, te Trgovac nema obavezu
        povraćaja novčanih sredstava naplaćenih za ulaznice kupljene od strane istog Kupca, ali
        posredstvom različitih korisničkih naloga.
      </p>
      <p>
        Po izvršenoj kupovini Korisniku će biti dostavljen email sa potvrdom i Ulaznicom, na
        osnovu koje stiče pravo korišćenja izabrane ulaznice. Navedenu potvrdu, Kupac je dužan da
        prezentuje Trgovcu prilikom ulaska na bazen.
      </p>
      <p>
        Kupljena ulaznica je jedinstvena i neprenosiva, putem iste se vrši identifikacija
        korisnika ulaznice, vodi evidencija dolazaka i uplata i istu je Kupac dužan pokazati na
        zahtev osoblja Trgovca. Kupac odgovara za ažurnost ličnih podataka, tačnu adresu i lične
        kontakte koje je dostavio Trgovcu. Smatra se da su važeći oni podaci koje je Kupac
        poslednje dao, osim ukoliko pisanim putem nije obavestio Trgovca o njihovoj promeni.
      </p>
      <p>
        Kupovinom Ulaznica Kupac prihvata da Trgovac može koristiti njegove lične podatke u
        svrhe pravilnog i potpunog izvršenja ugovornih obaveza, u skladu sa odredbama navedenim u
        Politici privatnosti koja reguliše opšte uslove prikupljanja, korišćenja i obrade ličnih
        podataka korisnika, koji predstavljaju sastavni deo ovih Opštih uslova.
      </p>
    </section>

    <section class="terms-section">
      <h2>V Rešavanje reklamacija Kupaca</h2>
      <p>
        Ovim delom Opštih uslova se, u skladu sa Zakonom o zaštiti potrošača, reguliše način
        izjavljivanja reklamacije, mesto prijema i način postupanja Trgovca po reklamacijama
        primljenim od strane Kupca.
      </p>
      <h3>Način izjavljivanja reklamacije</h3>
      <p>
        Kupci mogu reklamacije u vezi kupljenih Ulaznica podnositi Trgovcu. Reklamacije se mogu
        podneti na jedan od sledećih načina:
      </p>
      <ul>
        <li>Usmeno na bazenu za koji je kupljena ulaznica;</li>
        <li>Putem pošte na adresu Ulica Grada Sirena br. 15, Kragujevac;</li>
        <li>Elektronskim putem na mail adresu <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.</li>
      </ul>
      <p>
        Kupljene Ulaznice se mogu reklamirati samo uz dostavu na uvid email potvrde o kupljenim
        ulaznicama ili drugog relevantnog dokaza (kopija računa, slip i sl.) o kupovini. Trgovac
        je dužan da Kupcu kao potrošaču izda pisanu potvrdu ili elektronskim putem potvrdi prijem
        reklamacije, odnosno saopšti broj pod kojim je zavedena njegova reklamacija u evidenciji
        primljenih reklamacija.
      </p>
      <h3>Rok za odlučivanje po reklamaciji</h3>
      <p>
        Trgovac je dužan da bez odlaganja, a najkasnije u roku od osam dana od dana prijema
        reklamacije, pisanim ili elektronskim putem odgovori Kupcu kao potrošaču na izjavljenu
        reklamaciju.
      </p>
      <p>
        Odgovor Trgovca na reklamaciju Kupca kao potrošača mora da sadrži odluku da li prihvata
        reklamaciju, izjašnjenje o zahtevu Kupca i konkretan predlog i rok za rešavanje
        reklamacije. Rok za rešavanje reklamacije ne može da bude duži od 15 dana od dana
        podnošenja reklamacije. Trgovac je dužan da postupi u skladu sa odlukom, predlogom i
        rokom za rešavanje reklamacije, ukoliko je dobio prethodnu saglasnost Kupca. Ukoliko
        Trgovac iz objektivnih razloga nije u mogućnosti da udovolji zahtevu Kupca kao potrošača
        u roku koji je dogovoren, dužan je da o produžavanju roka za rešavanje reklamacije
        obavesti Kupca i navede rok u kome će je rešiti, kao i da dobije njegovu saglasnost, što
        je u obavezi da evidentira u evidenciji primljenih reklamacija. Produžavanje roka za
        rešavanje reklamacija moguće je samo jednom.
      </p>
      <p>
        Kupac koji je prethodno izjavio reklamaciju ili prigovor Trgovcu može da pokrene i
        odgovarajući postupak za vansudsko rešavanje sporova pred nadležnim telom u kome je
        Trgovac po Zakonu dužan da učestvuje.
      </p>
    </section>

    <section class="terms-section">
      <h2>VI Pravo Kupca na odustanak od Ugovora</h2>
      <p>
        U skladu sa Zakonom o zaštiti potrošača, a s obzirom da se Ulaznice prodaju na daljinu,
        Kupac ima pravo da odustane od Ugovora u roku od 14 dana od trenutka njegovog
        zaključenja. Momentom zaključenja Ugovora smatra se momenat kada je izvršena naplata
        Ulaznice.
      </p>
      <p>
        Pravo na odustanak od Ugovora, Kupac ostvaruje dostavljanjem Trgovcu popunjenog Obrasca
        za odustanak koji obrazac se dostavlja Kupcu na registrovanu mejl adresu prilikom slanja
        potvrde o plaćanju Ulaznice, a može se i preuzeti sa sajta Trgovca
        <a href="https://www.spdradnickikragujevac.com/" target="_blank" rel="noopener">www.spdradnickikragujevac.com</a>,
        a Trgovcu se može dostaviti putem emaila
        <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.
      </p>
      <p>
        U slučaju blagovremenog i osnovanog odustanka od Ugovora, Trgovac će izvršiti povraćaj
        svih primljenih uplata bez odlaganja, a najkasnije u roku od 14 dana od dana prijema
        obrasca za odustanak, korišćenjem istog sredstva plaćanja koje je Kupac koristio prilikom
        kupovine, osim ukoliko se Kupac izričito saglasi sa drugim načinom povraćaja.
      </p>
      <p>
        Kupac gubi pravo na odustanak od Ugovora ukoliko je pre isteka roka za odustanak započeo
        korišćenje Ulaznice, odnosno ukoliko je Ulaznica iskorišćena u celini ili delimično. U
        tom slučaju Trgovac nije u obavezi da izvrši povraćaj plaćenog iznosa.
      </p>
    </section>

    <section class="terms-section">
      <h2>VII Zaštita podataka o ličnosti</h2>
      <p>
        Podatak o ličnosti u smislu Zakona o zaštiti podataka o ličnosti je svaki podatak koji se
        odnosi na fizičko lice čiji je identitet određen ili odrediv, neposredno ili posredno,
        posebno na osnovu oznake identiteta, kao što je ime i identifikacioni broj, podatak o
        lokaciji, identifikator u elektronskim komunikacionim mrežama ili jednog, odnosno više
        obeležja njegovog fizičkog, fiziološkog, genetskog, mentalnog, ekonomskog, kulturnog i
        društvenog identiteta. Obrada podataka o ličnosti je svaka radnja ili skup radnji koje se
        vrše automatizovano ili neautomatizovano sa podacima o ličnosti ili njihovim skupovima,
        kao što su prikupljanje, beleženje, razvrstavanje, grupisanje, odnosno strukturisanje,
        pohranjivanje, upodobljavanje ili menjanje, otkrivanje. Sva pitanja od značaja za zaštitu
        podataka o ličnosti, obradu istih i Vaša prava po tom osnovu molimo da pročitate u
        Politici privatnosti.
      </p>
      <p>
        Trgovcu je zabranjeno prodavanje, naručivanje, obezbeđivanje ili razmena podataka
        potrošača ili informacija o platnoj kartici u bilo kojoj formi trećoj strani, sem ako to
        nije Banka ili nadležni državni organi. Lični i adresni podaci kupca koji se predočavaju
        Trgovcu prilikom procesa kupovine smatraju se poslovnom tajnom. Ovi podaci takođe su
        regulisani Zakonom o zaštiti podataka o ličnosti.
      </p>
      <p>
        Trgovac se obavezuje da od potrošača neće zahtevati i arhivirati u bilo kojoj
        elektronskoj formi, podatke vezane za platnu karticu kojom se transakcija realizuje, a
        posebno broj kartice, datum isticanja, CVC2 ili CVV broj, itd.
      </p>
      <p>
        Prihvatanjem ovih Uslova te korišćenjem Aplikacije potvrđujete da ste u celosti razumeli
        i prihvatili ove Uslove te ste ujedno obavešteni o pravnom osnovu, svrsi, opsegu i načinu
        korišćenja vaših ličnih podataka, odnosno da su Vam pružene informacije u skladu sa
        tačkom 23. Zakona o zaštiti podataka o ličnosti.
      </p>
    </section>

    <section class="terms-section">
      <h2>VIII Rešavanje sporova – nadležnost suda i merodavno pravo</h2>
      <p>
        Ugovorne strane su saglasne da sve eventualne nesporazume i sporna pitanja koja nastanu
        tokom trajanja ugovornog odnosa nastojati da reše mirnim putem. U slučaju da izostane
        mirno rešenje nesporazuma i spornih pitanja ugovara se nadležnost stvarno nadležnog suda
        u Kragujevcu, a primenjuje se pravo Republike Srbije.
      </p>
    </section>

    <section class="terms-section">
      <h2>IX Vansudsko rešavanje potrošačkih sporova</h2>
      <p>
        U skladu sa Zakonom o zaštiti potrošača, kupac može spor da reši u postupku vansudskog
        rešavanja spora, na način definisan Zakonom.
      </p>
    </section>

    <section class="terms-section">
      <h2>X Objavljivanje izmena Opštih uslova</h2>
      <p>
        Sve izmene ovih Opštih uslova Trgovac će blagovremeno istaći u Aplikaciji kao i na sajtu
        <a href="https://www.spdradnickikragujevac.com/" target="_blank" rel="noopener">www.spdradnickikragujevac.com</a>,
        koje će se primenjivati u roku od 8 dana od dana objavljivanja izmene. Kao i obično, ako
        se ne slažete s izmenama Opštih uslova, uvek imate opciju da zahtevate brisanje Vaših
        ličnih podataka iz naše baze.
      </p>
      <h3>Način na koji nas možete kontaktirati</h3>
      <p>
        Ukoliko imate bilo kakva pitanja ili zahteve u vezi Vaših ličnih podataka koje ste nam
        učinili dostupnim ili bilo koja druga pitanja o uslugama i aktuelnim ponudama možete nas
        kontaktirati na neki od sledećih načina:
      </p>
      <ul>
        <li>poštom na adresu sedišta Trgovca, Ulica Grada Sirena broj 15, Kragujevac;</li>
        <li>putem maila – <a href="mailto:office@spdradnicki.rs">office&#64;spdradnicki.rs</a>.</li>
      </ul>
      <p>
        Na sve što nije definisano ovim Opštim uslovima, primenjivaće se Zakon o obligacionim
        odnosima Republike Srbije i drugi propisi važeći u Republici Srbiji.
      </p>
      <p>
        Ovi Opšti uslovi poslovanja privrednog društva SPD Radnički doo Kragujevac doneti su i
        objavljeni na internet stranici
        <a href="https://www.spdradnickikragujevac.com/" target="_blank" rel="noopener">www.spdradnickikragujevac.com</a>
        i primenjuju se počev od {{ lastUpdated }} godine.
      </p>
    </section>

    <footer class="terms-footer">
      <p>&copy; {{ lastUpdated.slice(6, 10) }} SPD Radnički doo Kragujevac. Sva prava zadržana.</p>
    </footer>
  </div>
</div>
